import Button from "components/Button/Button";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Menu from "./Menu";
import { AiOutlineMenu, AiOutlineUser } from "react-icons/ai";
import logoImageSquare from "images/logo-wce-square.png";

const Navbar = ({ location, isAuth, name, isLoadAuth, handleShow }) => {
  const [offsetY, setOffsetY] = useState(0);
  const handleScroll = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHomepage = location?.pathname === "/";
  const isStart = isHomepage && offsetY < 50;

  return (
    <>
      <div
        className="sticky top-0 z-30 h-18 py-3 px-8 xl:px-16 hidden md:flex 
          items-center justify-between transition-all"
        style={{
          backgroundColor: isStart ? "#EAA7B8" : "#FFFFFF",
          boxShadow: isStart ? "" : "0px 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Menu isStart={isStart} />
        <div>
          {!isLoadAuth && !isAuth ? (
            <div className="flex gap-4">
              <Link to={"/login"}>
                <Button
                  rounded
                  size="large"
                  variant="secondary"
                  className="w-[102px]"
                >
                  Login
                </Button>
              </Link>
              <Link to="/register">
                <Button rounded size="large" className="w-[102px]">
                  Register
                </Button>
              </Link>
            </div>
          ) : !isLoadAuth && isAuth ? (
            <Link to={"/profile"}>
              <div
                className="flex items-center gap-4 ml-auto"
                style={{
                  color: isStart ? "#FFFFFF" : "#595959",
                }}
              >
                <AiOutlineUser size={24} />
                <span className="max-w-[150px] xl:max-w-full text-ellipsis whitespace-normal overflow-hidden">
                  {name || "Hi User"}
                </span>
              </div>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
      <div
        className="sticky top-0 z-30 h-18 py-3 px-8 xl:px-16 flex md:hidden 
          items-center justify-between transition-all"
        style={{
          backgroundColor: isStart ? "#EAA7B8" : "#FFFFFF",
          boxShadow: isStart ? "" : "0px 2px 8px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Button variant="link" onClick={handleShow}>
          <AiOutlineMenu
            size={20}
            className={`${isStart ? "text-white" : "text-wce-navy-light"}`}
          />
        </Button>
        <div className="absolute mx-auto left-0 right-0 w-9">
          <Link to="/">
            <img className="w-9 min-9" src={logoImageSquare} alt={"WCE Logo"} />
          </Link>
        </div>
        <div>
          {!isLoadAuth && !isAuth ? (
            <Link to={"/login"}>
              <Button rounded variant="secondary">
                Login
              </Button>
            </Link>
          ) : !isLoadAuth && isAuth ? (
            <Link to={"/profile"}>
              <div
                className="flex items-center ml-auto"
                style={{
                  color: isStart ? "#FFFFFF" : "#595959",
                }}
              >
                <AiOutlineUser size={24} />
              </div>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;
